/* eslint-disable no-unused-vars */
import {
  AuthCarouselProps,
  AuthModeSwitcherDataProps,
  ExtendedBenefits,
  FaqsPricing,
  LoginImageProps,
  RichtextItem,
  SubscriptionPlan,
} from "@/types/types";
import {
  bannerAdvantagesProps,
  bannerProps,
  billboardProps,
  faqs,
  faqsHomeTabProps,
  featuredAIProps,
  featuredProps,
  previewHome,
  qrEditorModuleProps,
} from "./home";
import { FormFieldProps } from "@/components/Form/types";
import { BannerProps, PreviewProps, TabsProps, ReasonsProps, BenefitsProps } from "./landingsSEM";
import { CtaStyle } from "@/components/Button/types";
import { APMs } from "@/components/Providers/MacropayProvider/types";
import { UserRole } from "@/config/rolePermissions";
import { QREditorModalDataProps } from "@/templates/QrEditorTemplates/qr-layout/types";
import { ChipProps } from "@/components/Chip/types";

export enum PAGES {
  HOME = "home",
  TERMS_AND_CONDITIONS = "terms-and-conditions",
  TERMS_OF_USE = "terms-of-use",
  PRIVACY_POLICY = "privacy-policy",
  COOKIES_POLICY = "cookies-policy",
  CONTACT_US = "contact-us",
  FAQ = "faq",
  PRICING = "pricing",
  WHOWEARE = "who-we-are",
  QR_EDITOR = "qr-editor",
  NOT_FOUND = "not-found",
  SIDEBAR = "sidebar",
  LOGIN = "login",
  REGISTER = "register",
  FORGOT_PASSWORD = "forgot-password",
  RESET_PASSWORD = "reset-password",
  SET_PASSWORD = "set-password",
  AUTH = "auth",
  INACTIVE = "inactive",
  THANK_YOU = "thank-you",
  PAYMENT = "payment",
  VERIFY_PAYMENT = "verify-payment",
  MY_QR_CODE_DETAILS = "my-qr-code-details",
  MY_QR_CODE_REVIEWS = "my-qr-code-reviews",
  BULK_CREATOR = "bulk-creator",
  TEMPLATES = "templates",
  TEMPLATES_EDIT = "template-editor",
  TEMPLATES_CREATE = "template-create",
  MY_QR_ANALYTICS = "my-qr-analytics",
  MY_ACCOUNT = "my-account",
  MY_QR_CODES = "my-qr-codes",
  QR_VIEW = "qr",
  MY_BILLING = "my-billing",
  USERS = "users",
  UNSUBSCRIBE = "unsubscribe",
  UNSUBSCRIBE_REASONS = "unsubscribe-reasons",
  UNSUBSCRIBE_CONFIRMATION = "unsubscribe-confirmation",
  QR_URL = "url",
  QR_VCARD = "vcard",
  QR_BUSINESS = "business",
  QR_SOCIAL = "social",
  QR_APPS = "apps",
  QR_VIDEO = "video",
  QR_MP3 = "mp3",
  QR_PDF = "pdf",
  QR_LISTOFLINKS = "listoflinks",
  QR_WIFI = "wifi",
  QR_IMAGE = "image",
  QR_YOUTUBE = "youtube",
  QR_WEBSITE = "website",
  QR_EVENT = "event",
  QR_COUPON = "coupon",
  QR_FEEDBACK = "feedback",
  QR_TEXT = "text",
  QR_EMAIL = "email",
  QR_URL_STATIC = "url-static",
  QR_SMS = "sms",
  QR_WHATSAPP = "whatsapp",
  QR_DESIGN = "qr-design",
  QR_REGISTER = "qr-register",
  QR_AI_DESIGN = "qr-design-ai",
  HOME_B = "qr-code-generator",
  GENERIC_ERRORS = "generic-errors",
  ERROR = "error",
  PDF_LANDING = "pdf-qr-code",
  VCARD_LANDING = "vcard-qr-code",
  QR_EDITOR_STATS = "qr-editor-stats",
  QR_EDITOR_LAYOUT = "qr-editor-layout",
}

export const previewTranslationNamespaces = [
  PAGES.QR_BUSINESS,
  PAGES.QR_EVENT,
  PAGES.QR_VCARD,
  PAGES.QR_COUPON,
  PAGES.QR_FEEDBACK,
  PAGES.QR_EDITOR_STATS,
  PAGES.QR_MP3,
  PAGES.QR_SOCIAL,
  PAGES.QR_APPS,
  PAGES.QR_VIDEO,
  PAGES.QR_PDF,
  PAGES.QR_LISTOFLINKS,
  PAGES.QR_IMAGE,
  PAGES.QR_WEBSITE,
  PAGES.QR_SMS,
  PAGES.QR_WHATSAPP,
  PAGES.QR_EMAIL,
  PAGES.QR_URL,
  PAGES.QR_URL_STATIC,
  PAGES.QR_WIFI,
];

export const QR_EDITOR_LAYOUT = "qr-editor-layout";

export interface IStaticPage {
  page: string;
  metaTitle: string;
  metaDescription: string;
  metaKeywords?: string;
  title?: string;
}
export interface IDashboardPage {
  page: string;
  title: string;
  DashboardAlertText?: string;
  DashboardAlertTextTrialActive1?: string;
  DashboardAlertTextTrialActive1_2?: string;
  DashboardAlertTextTrialActive2?: string;
  DashboardAlertTextTrialActive3_1?: string;
  DashboardAlertTextTrialActive3_2?: string;
  DashboardAlertTextTrialActive3_3?: string;
  DashboardAlertTextTrialExpired?: string;
  DashboardAlertBtnLabelTrialExpired?: string;
  dashboardAlertBtnLabel?: string;
}

export interface IUnsubscribePage extends IDashboardPage {
  backButtonLabel: string;
}

export interface I_StaticLegalPage extends IStaticPage {
  subtitle: string;
  richtext: RichtextItem[];
}

export interface I_InactivePage extends IStaticPage {
  image: string;
  richtext: RichtextItem[];
}

export interface PricingComponentProps {
  type: "SubscriptionPlansContainer" | "SubscriptionPlansWithPaymentContainer";
}

export interface PaymentComponentProps {
  type: "PaymentContainer" | "PaymentContainerWithBilling" | "NotFound";
  apms?: APMs[];
}
export interface I_PaymentPage extends IStaticPage {
  paymentComponent: PaymentComponentProps;
  uiRole?: UserRole;
  iframeTitle?: string;
  iframeTerms?: string;
  iframeTermsAB?: string;
  iframeRenew?: string;
  iframeSubmitButton?: string;
  iframeSubmitButtonAB?: string;
  paymentModuleTitle?: string;
  paymentModuleExpressCheckout: string;
  paymentModuleSubtitle?: string;
  paymentModuleCreditCard: string;
  paymentModuleCard: string;
  loadingTitle: string;
  loadingSubtitle: string;
  submitButton: string;
  submitButtonProcessing?: string;
  summarySelectionTitle?: string;
  summaryInfo?: string;
  summaryInfoTrial?: string;
  summaryLegal?: string;
  summaryOrderTitle?: string;
  summaryOrderMyPlan?: string;
  summaryOrderPlanPrice?: string;
  summaryOrderCode?: string;
  summaryOrderTotalAmount?: string;
  summaryOrderTotal?: string;
  summaryOrderMonthLabel?: string;
  summaryOrderEnterBillingDetailsText?: string;
  summaryContactTitle?: string;
  summaryContactInfoHighlighted?: string;
  summaryContactInfoText?: string;
  summaryContactInfoPhone?: string;
  summaryCertTitle: string;
  summaryCertInfoShort: string;
  summaryCertInfo: string;
  summaryFirstInfoTitle?: string;
  summaryFirstInfoContent?: string;
  summarySecondInfoTitle?: string;
  summarySecondInfoContent?: string;
  summaryThirdInfoTitle?: string;
  summaryThirdInfoContent?: string;
  textBeforeTimer?: string;
  textAfterTimer?: string;
  errorMessageTitle: string;
  errorMessageDescription: string;
  renewInfoTrial?: string;
  renewInfoNoTrial?: string;
}

export interface I_ThankYouPage {
  page: string;
  title: string;
  bannerTitle: string;
  bannerAction: {
    title: string;
    button: string;
    aiButton: string;
  };
}

export interface I_VerifyPaymentPage {
  page: string;
  loadingTitle: string;
  loadingSubtitle: string;
  apms?: APMs[];
}

export interface I_PrincingPage extends IStaticPage {
  mobileOnlyPlan?: {
    title: string;
    crossedOutPrice: number;
    saveChipLabel: string;
    saveChipColor: ChipProps["color"];
  };
  qrCodeReadyTitle?: string;
  countdownModule?: {
    timerText?: string;
  };
  socialProof?: {
    text_1: string;
    text_2: string;
    avatars: {
      image: string;
      alt: string;
      width: number;
      height: number;
    }[];
  };
  downloadButtonText?: string;
  downloadNowTitle?: string;
  fullAccessTitle?: string;
  successChipLabel?: string;
  submitButton?: string;
  subtitle_1: string | React.ReactNode;
  subtitle_2: string | React.ReactNode;
  ctaStyle?: CtaStyle;
  prices: SubscriptionPlan[];
  phone: {
    richtext: RichtextItem[];
  };
  banner?: {
    title: string;
    list: string[];
  };
  version?: string;
  continueButtonLabel?: string;
  containerComponent?: string;
  pricingComponent?: PricingComponentProps;
  couponError?: { [key: string]: string };
  benefitsExtended?: {
    title?: string;
    listExtended: ExtendedBenefits[];
  };
  faqs?: FaqsPricing;
  stats?: {
    firstColumnText_1?: string;
    firstColumnText_2?: string;
    secondColumnText_1?: string;
    secondColumnText_2?: string;
    thirdColumnText_1?: string;
    thirdColumnText_2?: string;
  };
  specialOffer?: {
    title: string;
    subtitle: string;
    descriptionText_1: string;
    descriptionText_2: string;
  };
  unlockFeaturesmodal?: QREditorModalDataProps;
}

export interface I_HomePage extends IStaticPage {
  billboard?: billboardProps;
  featured: featuredProps;
  featured2: featuredProps;
  featuredAI: featuredAIProps;
  banner: bannerAdvantagesProps;
  banner2: bannerProps;
  faqsHomeTabs: faqsHomeTabProps[];
  faqsHome: faqs;
  previewHome: previewHome;
  qrEditorCompact?: qrEditorModuleProps;
  previewTranslations?: any;
}

export interface I_ResetPasswordPage extends IStaticPage {
  formFields: FormFieldProps[];
  successTitle: string;
  successSubtitle: string;
  successSubtitle_2: string;
  acceptButton: string;
  carousel: AuthCarouselProps[];
}

export interface I_SetPasswordPage extends I_ResetPasswordPage {
  invalidLinkToast: string;
}

export interface I_ForgotPasswordPage extends IStaticPage {
  subtitle: string;
  formFields: FormFieldProps[];
  goBack: string;
  successTitle: string;
  successSubtitle: string;
  successButton: string;
  resendEmailLink: string;
  carousel: AuthCarouselProps[];
}
export interface I_QREditorFormTemplate {
  page: string;
  metaTitle: string;
  metaDescription: string;
  title: string;
  formFields: FormFieldProps[];
  layoutTranslations?: any;
}

export interface I_QREditorDesignForm {
  page: string;
  metaTitle: string;
  metaDescription: string;
  title: string;
  formFields: FormFieldProps[];
  selectorTitle: string;
  selectorSubtitle: string;
}

export interface I_LoginPage extends IStaticPage {
  formFields: FormFieldProps[];
  invalidAuthMessage: string;
  invalidAuthGoogleMessage: string;
  invalidAuthSSOMessage: string;
  authModeSwitcher: AuthModeSwitcherDataProps;
  loginImage: LoginImageProps;
}

export interface I_RegisterPage extends IStaticPage {
  formFields: FormFieldProps[];
  invalidAuthMessage: string;
  invalidAuthGoogleMessage: string;
  invalidAuthSSOMessage: string;
  authModeSwitcher: AuthModeSwitcherDataProps;
  disclaimer: string;
  carousel: AuthCarouselProps[];
}

export interface I_LandingPage extends IStaticPage {
  preview: PreviewProps;
  banner: BannerProps;
  landingTabs: TabsProps;
  landingBenefits: BenefitsProps;
  landingReasons: ReasonsProps;
  defaultPreviewTitle?: string;
  previewTranslations?: any;
}
